import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("fp_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("fp_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    const minQty = Math.max(1, Number(product.min_qty) || 1);
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.id);
      if (existing) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: Math.max(minQty, i.quantity + qty) } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          reference: product.reference || "",
          price: product.price || 0,
          image: (product.images && product.images[0]) || "",
          slug: product.slug,
          min_qty: minQty,
          quantity: Math.max(minQty, qty),
        },
      ];
    });
  };

  const updateQty = (id, qty) =>
    setItems((prev) =>
      prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(i.min_qty || 1, qty) } : i))
    );
  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}
